module.exports = __webpack_public_path__ + "static/img/8.dd52eb4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/brand/8.png
// module id = ZIJL
// module chunks = 45